// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_P2h","cls2":"Comments-cls2_NGf Comments-cls1_P2h"};